import React, { useState, useEffect } from 'react';

const Timer = ({ setSeconds, seconds, setRespondido, inicioConversacion }) => {
  const [isActive, setIsActive] = useState(false);

  const [time, setTime] = useState({
    sec: 0,
    min: 0,
  });

  function toggle() {
    setIsActive(prev => !prev);
  }

  function reset() {
    setSeconds(0);
    setIsActive(false);
    setTime({ sec: 0, min: 0 });
  }

  const printTime = (t) => {
    const minutes = Math.floor(t / 60);
    const secs = t % 60;

    return `${minutes < 10 ? '0' + minutes : minutes}:${secs < 10 ? '0' + secs : secs}`;
  };

  // ⏱ timer seguro
  useEffect(() => {
    if (!isActive) return;

    const interval = setInterval(() => {
      setSeconds(prev => prev + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [isActive, setSeconds]);

  // sincroniza tiempo visual
  useEffect(() => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;

    setTime({
      sec: secs,
      min: minutes,
    });
  }, [seconds]);

  // 🎨 botón reutilizable (MISMO diseño que tenías)
  const ResetButton = () => (
    <a
      className="btn"
      style={{
        flex: 1,
        color: '#fff',
        backgroundColor: '#808080',
        borderColor: '#808080',
      }}
      onMouseEnter={(e) => {
        e.target.style.backgroundColor = '#5f5f5f';
        e.target.style.borderColor = '#5f5f5f';
      }}
      onMouseLeave={(e) => {
        e.target.style.backgroundColor = '#808080';
        e.target.style.borderColor = '#808080';
      }}
      onMouseDown={(e) => {
        e.target.style.backgroundColor = '#4a4a4a';
      }}
      onMouseUp={(e) => {
        e.target.style.backgroundColor = '#5f5f5f';
      }}
      onClick={reset}
    >
      Reiniciar
    </a>
  );

  return (
    <div className="p-3 text-center">
      <h5>Tiempo de llamada</h5>

      <div
        className="row d-flex flex-column justify-content-center align-items-center p-3"
        style={{ fontSize: '25px' }}
      >
        <span>
          {time.min < 10 ? '0' + time.min : time.min}:
          {time.sec < 10 ? '0' + time.sec : time.sec}
        </span>

        {inicioConversacion > 0 && (
          <span style={{ color: '#9A89A4', fontSize: '14px', marginTop: '10px' }}>
            Respondido: {printTime(inicioConversacion)}
          </span>
        )}
      </div>

      {!isActive ? (
        <>
          <div className="row d-flex justify-content-center align-items-center mb-2">
            <a
              className="btn btn-dark"
              style={{ color: '#fff', width: '100%' }}
              onClick={toggle}
            >
              Timbrar
            </a>

          </div>

          <div className="row d-flex justify-content-center align-items-center">
            {inicioConversacion === 0 ? (
              <a
                className="btn btn-success"
                style={{ color: '#fff', flex: 1 }}
                onClick={() => setRespondido(seconds)}
              >
                Respondido
              </a>
            ) : null}

            <ResetButton />
          </div>
        </>
      ) : (
        <>
          <div className="row d-flex justify-content-center align-items-center mb-2">
            {inicioConversacion === 0 ? (
              <a
                className="btn btn-success"
                style={{ color: '#fff', width: '100%' }}
                onClick={() => setRespondido(seconds)}
              >
                Respondido
              </a>
            ) : null}
          </div>

          <div className="row d-flex justify-content-center align-items-center">
            <a
              className="btn btn-danger"
              style={{ color: '#fff', flex: 1 }}
              onClick={toggle}
            >
              Colgar
            </a>

            <ResetButton />
          </div>
        </>
      )}
    </div>
  );
};

export default Timer;